import { generateSalePercentageBasedOnType } from 'utils';
import srcSaleBadge from 'assets/LightningLink/sale-badge-v2.png';
import { ESaleDiscountDisplayType } from 'utils/enums';
import { StyledLightningLinkSaleBadge } from './style';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { SaleBadgeProps } from '../../types';

export const LightningLinkSaleBadge = ({
  salePercentage,
  salePercentageDisplayType = ESaleDiscountDisplayType.PERCENTAGE,
}: SaleBadgeProps) => {
  return (
    <StyledLightningLinkSaleBadge>
      <img src={srcSaleBadge} alt="sale-badge" />
      <AutoTextSize
        as="span"
        mode="box"
        maxFontSizePx={10}
        minFontSizePx={6}
        className="number"
      >
        {generateSalePercentageBasedOnType(
          salePercentage,
          salePercentageDisplayType,
        )}{' '}
        MORE
      </AutoTextSize>
    </StyledLightningLinkSaleBadge>
  );
};
